module.exports = __webpack_public_path__ + "static/media/groovy-ale-thumb.d9d4f4fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/groovy-ale-thumb.jpg
// module id = 595
// module chunks = 0